<router-outlet></router-outlet>

<div id="app-version">v2.4.0</div>